import CryptoJS from "crypto-js";
import config from "react-global-configuration";
var key = config.get('key');
var iv = config.get('iv');

export const AESDecryption = (cipherText) => {
    let cipherParams = CryptoJS.lib.CipherParams.create({
            ciphertext: CryptoJS.enc.Base64.parse(cipherText)
        });

    let decrypted = CryptoJS.AES.decrypt(
        cipherParams,
        CryptoJS.enc.Base64.parse(key),
        {
            iv: CryptoJS.enc.Base64.parse(iv),
        });
    return decrypted.toString(CryptoJS.enc.Utf8);
}

export const AESEncryption = (plainText) => {
    var encrypted = CryptoJS.AES.encrypt(
        plainText,
        CryptoJS.enc.Base64.parse(key),
        {
            iv: CryptoJS.enc.Base64.parse(iv)
        });
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
}

export const AESDecryptionParam = (cipherText) => {   
    let cipherParams = CryptoJS.lib.CipherParams.create({
        ciphertext: CryptoJS.enc.Base64.parse(cipherText.replace(/\ /g, '/'))
    });

    let decrypted = CryptoJS.AES.decrypt(
        cipherParams,
        CryptoJS.enc.Base64.parse(key),
        {
            iv: CryptoJS.enc.Base64.parse(iv),
        });
    return decrypted.toString(CryptoJS.enc.Utf8);
}

export const AESEncryptionParam = (plainText) => {
    var encrypted = CryptoJS.AES.encrypt(
        plainText,
        CryptoJS.enc.Base64.parse(key),
        {
            iv: CryptoJS.enc.Base64.parse(iv)
        });
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64).replace(/\//g, ' ');
}


//var AesUtil = function (keySize, iterationCount) {
//    this.keySize = keySize / 32;
//    this.iterationCount = iterationCount;
//};

//AesUtil.prototype.generateKey = function (salt, passPhrase) {
//    var key = CryptoJS.PBKDF2(
//        passPhrase,
//        CryptoJS.enc.Hex.parse(salt),
//        { keySize: this.keySize, iterations: this.iterationCount });
//    return key;
//};

//AesUtil.prototype.encrypt = function (salt, iv, passPhrase, plainText) {
//    var key = this.generateKey(salt, passPhrase);
//    var encrypted = CryptoJS.AES.encrypt(
//        plainText,
//        key,
//        { iv: CryptoJS.enc.Hex.parse(iv) });
//    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
//};

//AesUtil.prototype.decrypt = function (key, iv, cipherText) {
//    var cipherParams = CryptoJS.lib.CipherParams.create({
//        ciphertext: CryptoJS.enc.Base64.parse(cipherText)
//    });
//    var decrypted = CryptoJS.AES.decrypt(
//        cipherParams,
//        CryptoJS.enc.Hex.parse(key),
//        { iv: CryptoJS.enc.Hex.parse(iv) });
//    return decrypted.toString(CryptoJS.enc.Utf8);
//};
